let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("88uaN")).then(() => parcelRequire('dSYY6'));